import React from "react";
import { Navigate } from "react-router-dom";
import AdminReports from "./admin-reports";
import AdminYouthRegistrations from "./admin-report-youth-registration";
import AdminHostRegistrations from "./admin-report-host-registration";

export const AdminReportsRoutes = {
  settings: {
    layout: {},
  },
  routes: [
    {
      path: "reports",
      element: <AdminReports />,
      children: [
        {
          path: "",
          element: <Navigate to="youth-registrations" />,
        },
        {
          path: "youth-registrations",
          element: <AdminYouthRegistrations />,
        },
        {
          path: "host-registrations",
          element: <AdminHostRegistrations />,
        },
        {
          path: "incentive-report",
          element: <></>,
        },
        {
          path: "hourly-rate",
          element: <></>,
        },
        {
          path: "transfers",
          element: <></>,
        },
        {
          path: "concerns",
          element: <></>,
        },
        {
          path: "time-management",
          element: <></>,
        },
        {
          path: "payments",
          element: <></>,
        },
      ],
    },
  ],
};
